"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWhirlpoolProgramId = exports.getWhirlpoolsConfig = void 0;
const web3_js_1 = require("@solana/web3.js");
const network_1 = require("./public/network");
function getWhirlpoolsConfig(network) {
    switch (network) {
        case network_1.OrcaNetwork.MAINNET:
            return new web3_js_1.PublicKey("2LecshUwdy9xi7meFgHtFJQNSKk4KdTrcpvaB56dP2NQ");
        case network_1.OrcaNetwork.DEVNET:
            return new web3_js_1.PublicKey("847gd7SckNwJetbjf22ktip9vAtKWPMY4ntdr6CdCsJj");
        default:
            throw new Error(`type ${network} is an Unknown network`);
    }
}
exports.getWhirlpoolsConfig = getWhirlpoolsConfig;
function getWhirlpoolProgramId(network) {
    switch (network) {
        case network_1.OrcaNetwork.MAINNET:
            return new web3_js_1.PublicKey("whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc");
        case network_1.OrcaNetwork.DEVNET:
            return new web3_js_1.PublicKey("whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc");
        default:
            throw new Error(`type ${network} is an Unknown network`);
    }
}
exports.getWhirlpoolProgramId = getWhirlpoolProgramId;
